<script>
import 'floating-vue/dist/style.css';
import {Dropdown} from 'floating-vue'

const DELAY = 4 * 1000;
const DELAY_BETWEEN_TOOLTIPS = 0.5 * 1000;
export default {
  name: "TimedTooltip",

  components: {Dropdown},

  props: {
    hidden: {
      required: false,
      type: Boolean,
      default: false
    },
    position: {
      // https://floating-vue.starpad.dev/guide/component#placements
      required: false,
      type: String,
      default: 'bottom-end'
    }
  },

  data: () => ({
    show: false,
    content: '',
    tooltipQueue: [],
    timerId: null
  }),

  watch: {
    '$store.getters.getNotificationTooltip': {
      immediate: true,
      handler(value) {
        if (!value) {
          return;
        }

        this.tooltipQueue.push(value)

        if (!this.show) {
          this.showNextTooltip();
        }
      },
    },
    hidden(value) {
      if (value) {
        this.tooltipQueue = [];
      }
    }
  },

  methods: {
    showNextTooltip() {
      if (this.tooltipQueue.length > 0) {
        this.content = this.tooltipQueue.shift();

        this.show = true;

        this.timerId = setTimeout(() => {
          this.close();

          setTimeout(() => {
            this.showNextTooltip();
          }, DELAY_BETWEEN_TOOLTIPS); // Needed in order to animation on appear to work on every tooltip
        }, DELAY);
      }
    },

    close() {
      clearTimeout(this.timerId);
      this.show = false;
      this.$store.dispatch('hideNotificationTooltip');
    },

    manualClose() {
      this.close();

      setTimeout(() => {
        this.showNextTooltip();
      }, DELAY_BETWEEN_TOOLTIPS);
    }
  },
}
</script>

<template>
  <Dropdown :shown="show && !hidden" :triggers="[]" :autoHide="false" :placement="position" :distance="20">
    <div @click="manualClose">
      <slot></slot>
    </div>

    <template #popper>
      <p class="timed-tooltip-content" v-html="content"></p>
      <div class="loading"></div>
    </template>
  </Dropdown>
</template>

<style scoped lang="scss">
.timed-tooltip-content {
  font-weight: 500;
  padding: 10px;
  isolation: isolate;
}

.loading {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%;
  overflow: hidden;
}

.loading::before,
.loading::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  background-size: 100% 3px;
  background: white;
  animation: countdown 4s linear forwards;
}

@keyframes countdown {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.loading::before {
  left: 0;
  transform-origin: right;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.loading::after {
  right: 0;
  transform-origin: left;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

</style>

<!-- Not scoped, be careful -->
<style lang="scss">
.v-popper__arrow-container {
  .v-popper__arrow-outer, .v-popper__arrow-inner {
    border-color: var(--v-main-light-base);
  }
}

.v-popper__popper.v-popper__popper--shown {
  z-index: 5;

  @media screen and (max-width: 768px) {
    z-index: 999;
  }
}

.v-popper--theme-dropdown .v-popper__inner {
  font-family: Barlow, sans-serif;
  background: linear-gradient(
      -35deg,
      var(--v-main-light-base) 27%,
      var(--v-main-lighter-base) 100%
  );
  border: none;
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  color: white;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 2px, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-2px, -2px, 0);
  }

  40%, 60% {
    transform: translate3d(2px, 0, 0);
  }
}
</style>